// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-form {
  margin-top: 10px;
  margin-left: 10px;
  display: flex
}

.event-container {
  width: calc(100% - 20px);
  margin-top: 10px;
  margin-left: 10px;
  display: flex;
}

.btn-modal-event {
	width: 100%;
}

.calendar-form {
  padding: 6px 0;
  cursor: pointer;
  width: 100%;
}

.datepicker {
  padding: 6px 0;
  cursor: pointer;
  width: 100%;
}

.date-panel {
  margin-top: 0;
  margin-left: 60px;
  margin-right: 10px;
}

.border {
  margin-top: 7px;
  padding-top: 7px;
  border-top: 1px solid #e5e5e5
}

.input-group {
  width: 100%;
  margin-left: 0;
  display: flex;
  top: 2px;
}

.label-date {
  color: #1a252f;;
  display: flex;
  vertical-align: middle;
  padding: .7em 1em;
  margin-right: auto;
}

.time-span {
  background: #0077B5;
  border-radius: 2px;
  color: #fff;
  font-size: 13px;
  top: 2px;
  padding: .6em 1em;
}

.display-time {
  display: flex;
  justify-content: space-between;
  margin-left: auto;
}

.display-period {
  margin-top: 5px;
}

.event-status {
  color: #333;
  margin: 8px 0 8px 20px;
}

/** Toggles tab**/
.togglebutton {
  vertical-align: middle;
}
.togglebutton,
.togglebutton label,
.togglebutton input,
.togglebutton .toggle {
  -webkit-user-select: none;
          user-select: none;
}
.togglebutton label {
  cursor: pointer;
  color: rgba(0,0,0, 0.26);
}
.form-group.is-focused .togglebutton label {
  color: rgba(0,0,0, 0.26);
}
.form-group.is-focused .togglebutton label:hover,
.form-group.is-focused .togglebutton label:focus {
  color: rgba(0,0,0, .54);
}
fieldset[disabled] .form-group.is-focused .togglebutton label {
  color: rgba(0,0,0, 0.26);
}
.togglebutton label input[type=checkbox] {
  opacity: 0;
  width: 0;
  height: 0;
}
.togglebutton label .toggle {
  text-align: left;
}
.togglebutton label .toggle,
.togglebutton label input[type=checkbox][disabled] + .toggle {
  content: "";
  display: inline-block;
  margin-left: 30px;
  width: 30px;
  height: 15px;
  background-color: rgba(80, 80, 80, 0.7);
  border-radius: 15px;
  margin-right: 15px;
  transition: background 0.3s ease;
  vertical-align: middle;
}
.togglebutton label .toggle:after {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: #F1F1F1;
  border-radius: 20px;
  position: relative;
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4);
  left: -5px;
  top: -2px;
  transition: left 0.3s ease, background 0.3s ease, box-shadow 0.1s ease;
}

.togglebutton label input[type=checkbox][disabled] + .toggle:after,
.togglebutton label input[type=checkbox][disabled]:checked + .toggle:after {
  background-color: #BDBDBD;
}
.togglebutton label input[type=checkbox] + .toggle:active:after,
.togglebutton label input[type=checkbox][disabled] + .toggle:active:after {
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4), 0 0 0 15px rgba(0, 0, 0, 0.1);
}

.togglebutton label input[type=checkbox]:checked + .toggle {
  background-color: rgba(0, 119, 181, 0.5);
}
.togglebutton label input[type=checkbox]:checked + .toggle:after {
  background-color: #0077B5;
  left: 15px;
}
.togglebutton label input[type=checkbox]:checked + .toggle:active:after {
  box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4), 0 0 0 15px rgba(0, 150, 136, 0.1);
}

/** Selected button **/

::ng-deep .p-button {
  white-space: nowrap;
  font-size: 14px;
}

::ng-deep .p-component {
  background-color: #ffffff;
  color: #3498db;
  border-radius: 2px;
  padding: .3em 1em;
}

::ng-deep .p-component.p-highlight{
  background-color: #3498db;
  color: #ffffff !important;
  border-radius: 2px;
  padding: .3em 1em;
}

/** Display All-Day row **/
.slds-modal .input-group-addon + .togglebutton {
	margin-left: 50px;
	padding-top: 1px;
}

.slds-modal .togglebutton label {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	color: #333;
	margin: 6px 0;
}

/** Buttons **/
.slds-modal__header .btn {
	margin: 0;
	margin-left: auto;
	color: #fff;
	padding: 0;
	margin-right: 10px;
}

.slds-modal__header .btn:not(.btn-raised):not(.btn-link):hover {
  color: #333;
  text-decoration: none;
}

.btn:not(.btn-raised),
.input-group-btn .btn:not(.btn-raised),
.btn:not(.btn-raised).btn-default,
.input-group-btn .btn:not(.btn-raised).btn-default {
  color: rgba(0,0,0, 0.87);
}

.btn-modal-event-off-duty, .btn-modal-event-train, .btn-modal-event-sick, .btn-modal-event-kids, .btn-modal-event-phol, .btn-modal-event-oth, .btn-modal-event-techz,
.btn-modal-event-trainz,.btn-modal-event-confz,.btn-modal-event-casualz, .btn-modal-event-hbw {
	font-weight: 400;
	text-transform: none;
	padding-top: 55px;
}

.btn-modal-event-off-duty:hover, .btn-modal-event-train:hover, .btn-modal-event-sick:hover, .btn-modal-event-kids:hover, .btn-modal-event-phol:hover,
.btn-modal-event-oth:hover, .btn-modal-event-techz:hover, .btn-modal-event-trainz:hover, .btn-modal-event-confz:hover, .btn-modal-event-casualz:hover,
.btn-modal-event-hbw:hover, .btn-modal-event-off-duty.active, .btn-modal-event-train.active, .btsn-modal-event-sick.active, .btsn-modal-event-kids.active,
.btn-modal-event-phol.active, .btn-modal-event-oth.active, .btn-modal-event-techz:active,.btn-modal-event-trainz:active, .btn-modal-event-confz:active,
.btn-modal-event-casualz:active, .btn-modal-event-hbw.active {
	background: #eaeaea;
}

.btn:not(.btn-raised):not(.btn-link).not-editable:hover {
	background: none;
	cursor: default;
}

.btn-modal-event-off-duty:before, .btn-modal-event-train:before, .btn-modal-event-sick:before, .btn-modal-event-kids:before,
.btn-modal-event-phol:before, .btn-modal-event-oth:before, .btn-modal-event-techz:before, .btn-modal-event-trainz:before, .btn-modal-event-confz:before,
 .btn-modal-event-casualz:before, .btn-modal-event-hbw:before {
	font-family: "Material Icons";
	font-size: 34px;
	position: absolute;
	content: '';
	top: 5px;
	left: 50%;
	transform: translateX(-50%);
}
.btn-modal-event-off-duty:before {
	content: "\\E430";
	color: #f39c12; /* Off duty color */
}
.btn-modal-event-train:before {
	content: "\\E80C";
	color: #9b59b6; /* Training color */
}
.btn-modal-event-sick:before {
	content: "\\E53A";
	color: #c0392b; /* Sick color */
}
.btn-modal-event-kids:before {
	content: "\\F19B";
	color: #d46659; /* Kids color */
}
.btn-modal-event-phol:before {
	content: "\\E16B";
	color: #0077B5; /* Phol color */
}
.btn-modal-event-hbw:before {
	content: "\\E88A";
	color: #c0aa16; /* Home based working color */
}
.btn-modal-event-oth:before {
	content: "\\E878";
	color: #1abc9c; /* Other color */
}

.slds-modal__header .btn:not(.btn-raised):not(.btn-link):hover {
	background: inherit;
}

/** Selected button **/

::ng-deep .p-selectbutton .p-button.p-state-default {
  border: none;
	background: #ffffff;
	color: #0077B5;
}

::ng-deep .p-selectbutton .p-button.p-state-active {
  background: #0077B5;
  color: #FFFFFF;
}

/** Datepicker **/

::ng-deep .custom-p-calendar {
  width: auto;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  position: fixed !important;
  bottom: 300px;
  left: 70px;
}

::ng-deep .p-datepicker {
  color: #333;
}

::ng-deep .p-datepicker-header {
  padding: 10px;
  color: #333;
}

::ng-deep.p-datepicker-title {
	margin: 6px 35px;
  display: flex;
  justify-content: space-between;
}

::ng-deep .p-datepicker-title .p-datepicker-year {
	margin-left: 6px;
}

::ng-deep .p-datepicker table th {
  background-color: #E0E0E0;
  padding: 5px;
}

::ng-deep .p-datepicker table td > span {
  background-color: #ffffff;
  padding: 10px;
}

::ng-deep .p-datepicker table td:hover > span {
  background-color: #E0E0E0;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #E0E0E0;
}

::ng-deep .p-datepicker table td.p-datepicker-today > span {
  background-color: #0077B5;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #0077B5;
}

::ng-deep .p-datepicker table td.p-datepicker-other-month > span {
  color: #E0E0E0;
}

::ng-deep .p-datepicker table td.p-datepicker-other-month:hover > span {
  background-color: #EEEEEE;
  color: #ffffff;
  padding: 8px;
  border-radius: 50%;
  outline: 1px solid #EEEEEE;
}

::ng-deep span.p-disabled {
  color: #d3d3d3;
}

/* Small devices (tablets, 768px and up) */
@media (max-width: 768px) {
  #type-event {
    display: flex;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/Modals/inputmodal.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB;AACA;;;;EAIE,yBAAyB;UAGjB,iBAAiB;AAC3B;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAGV,gCAAgC;EACxC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAEV,4CAA4C;EACpD,UAAU;EACV,SAAS;EAGD,sEAAsE;AAChF;;AAEA;;EAEE,yBAAyB;AAC3B;AACA;;EAGU,2EAA2E;AACrF;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;AACA;EAEU,+EAA+E;AACzF;;AAEA,sBAAsB;;AAEtB;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,8BAA8B;CAC9B,mBAAmB;CACnB,WAAW;CACX,aAAa;AACd;;AAEA,cAAc;AACd;CACC,SAAS;CACT,iBAAiB;CACjB,WAAW;CACX,UAAU;CACV,kBAAkB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;CAEC,gBAAgB;CAChB,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;;;;;CAKC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;;CAGC,6BAA6B;CAC7B,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,SAAS;CACT,2BAA2B;AAC5B;AACA;CACC,gBAAgB;CAChB,cAAc,EAAE,mBAAmB;AACpC;AACA;CACC,gBAAgB;CAChB,cAAc,EAAE,mBAAmB;AACpC;AACA;CACC,gBAAgB;CAChB,cAAc,EAAE,eAAe;AAChC;AACA;CACC,gBAAgB;CAChB,cAAc,EAAE,eAAe;AAChC;AACA;CACC,gBAAgB;CAChB,cAAc,EAAE,eAAe;AAChC;AACA;CACC,gBAAgB;CAChB,cAAc,EAAE,6BAA6B;AAC9C;AACA;CACC,gBAAgB;CAChB,cAAc,EAAE,gBAAgB;AACjC;;AAEA;CACC,mBAAmB;AACpB;;AAEA,sBAAsB;;AAEtB;EACE,YAAY;CACb,mBAAmB;CACnB,cAAc;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;CACC,gBAAgB;EACf,aAAa;EACb,8BAA8B;AAChC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":[".modal-form {\n  margin-top: 10px;\n  margin-left: 10px;\n  display: flex\n}\n\n.event-container {\n  width: calc(100% - 20px);\n  margin-top: 10px;\n  margin-left: 10px;\n  display: flex;\n}\n\n.btn-modal-event {\n\twidth: 100%;\n}\n\n.calendar-form {\n  padding: 6px 0;\n  cursor: pointer;\n  width: 100%;\n}\n\n.datepicker {\n  padding: 6px 0;\n  cursor: pointer;\n  width: 100%;\n}\n\n.date-panel {\n  margin-top: 0;\n  margin-left: 60px;\n  margin-right: 10px;\n}\n\n.border {\n  margin-top: 7px;\n  padding-top: 7px;\n  border-top: 1px solid #e5e5e5\n}\n\n.input-group {\n  width: 100%;\n  margin-left: 0;\n  display: flex;\n  top: 2px;\n}\n\n.label-date {\n  color: #1a252f;;\n  display: flex;\n  vertical-align: middle;\n  padding: .7em 1em;\n  margin-right: auto;\n}\n\n.time-span {\n  background: #0077B5;\n  border-radius: 2px;\n  color: #fff;\n  font-size: 13px;\n  top: 2px;\n  padding: .6em 1em;\n}\n\n.display-time {\n  display: flex;\n  justify-content: space-between;\n  margin-left: auto;\n}\n\n.display-period {\n  margin-top: 5px;\n}\n\n.event-status {\n  color: #333;\n  margin: 8px 0 8px 20px;\n}\n\n/** Toggles tab**/\n.togglebutton {\n  vertical-align: middle;\n}\n.togglebutton,\n.togglebutton label,\n.togglebutton input,\n.togglebutton .toggle {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.togglebutton label {\n  cursor: pointer;\n  color: rgba(0,0,0, 0.26);\n}\n.form-group.is-focused .togglebutton label {\n  color: rgba(0,0,0, 0.26);\n}\n.form-group.is-focused .togglebutton label:hover,\n.form-group.is-focused .togglebutton label:focus {\n  color: rgba(0,0,0, .54);\n}\nfieldset[disabled] .form-group.is-focused .togglebutton label {\n  color: rgba(0,0,0, 0.26);\n}\n.togglebutton label input[type=checkbox] {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.togglebutton label .toggle {\n  text-align: left;\n}\n.togglebutton label .toggle,\n.togglebutton label input[type=checkbox][disabled] + .toggle {\n  content: \"\";\n  display: inline-block;\n  margin-left: 30px;\n  width: 30px;\n  height: 15px;\n  background-color: rgba(80, 80, 80, 0.7);\n  border-radius: 15px;\n  margin-right: 15px;\n  -webkit-transition: background 0.3s ease;\n       -o-transition: background 0.3s ease;\n          transition: background 0.3s ease;\n  vertical-align: middle;\n}\n.togglebutton label .toggle:after {\n  content: \"\";\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background-color: #F1F1F1;\n  border-radius: 20px;\n  position: relative;\n  -webkit-box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4);\n          box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4);\n  left: -5px;\n  top: -2px;\n  -webkit-transition: left 0.3s ease, background 0.3s ease, -webkit-box-shadow 0.1s ease;\n       -o-transition: left 0.3s ease, background 0.3s ease, box-shadow 0.1s ease;\n          transition: left 0.3s ease, background 0.3s ease, box-shadow 0.1s ease;\n}\n\n.togglebutton label input[type=checkbox][disabled] + .toggle:after,\n.togglebutton label input[type=checkbox][disabled]:checked + .toggle:after {\n  background-color: #BDBDBD;\n}\n.togglebutton label input[type=checkbox] + .toggle:active:after,\n.togglebutton label input[type=checkbox][disabled] + .toggle:active:after {\n  -webkit-box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4), 0 0 0 15px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4), 0 0 0 15px rgba(0, 0, 0, 0.1);\n}\n\n.togglebutton label input[type=checkbox]:checked + .toggle {\n  background-color: rgba(0, 119, 181, 0.5);\n}\n.togglebutton label input[type=checkbox]:checked + .toggle:after {\n  background-color: #0077B5;\n  left: 15px;\n}\n.togglebutton label input[type=checkbox]:checked + .toggle:active:after {\n  -webkit-box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4), 0 0 0 5px rgba(0, 150, 136, 0.1);\n          box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.4), 0 0 0 15px rgba(0, 150, 136, 0.1);\n}\n\n/** Selected button **/\n\n::ng-deep .p-button {\n  white-space: nowrap;\n  font-size: 14px;\n}\n\n::ng-deep .p-component {\n  background-color: #ffffff;\n  color: #3498db;\n  border-radius: 2px;\n  padding: .3em 1em;\n}\n\n::ng-deep .p-component.p-highlight{\n  background-color: #3498db;\n  color: #ffffff !important;\n  border-radius: 2px;\n  padding: .3em 1em;\n}\n\n/** Display All-Day row **/\n.slds-modal .input-group-addon + .togglebutton {\n\tmargin-left: 50px;\n\tpadding-top: 1px;\n}\n\n.slds-modal .togglebutton label {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: #333;\n\tmargin: 6px 0;\n}\n\n/** Buttons **/\n.slds-modal__header .btn {\n\tmargin: 0;\n\tmargin-left: auto;\n\tcolor: #fff;\n\tpadding: 0;\n\tmargin-right: 10px;\n}\n\n.slds-modal__header .btn:not(.btn-raised):not(.btn-link):hover {\n  color: #333;\n  text-decoration: none;\n}\n\n.btn:not(.btn-raised),\n.input-group-btn .btn:not(.btn-raised),\n.btn:not(.btn-raised).btn-default,\n.input-group-btn .btn:not(.btn-raised).btn-default {\n  color: rgba(0,0,0, 0.87);\n}\n\n.btn-modal-event-off-duty, .btn-modal-event-train, .btn-modal-event-sick, .btn-modal-event-kids, .btn-modal-event-phol, .btn-modal-event-oth, .btn-modal-event-techz,\n.btn-modal-event-trainz,.btn-modal-event-confz,.btn-modal-event-casualz, .btn-modal-event-hbw {\n\tfont-weight: 400;\n\ttext-transform: none;\n\tpadding-top: 55px;\n}\n\n.btn-modal-event-off-duty:hover, .btn-modal-event-train:hover, .btn-modal-event-sick:hover, .btn-modal-event-kids:hover, .btn-modal-event-phol:hover,\n.btn-modal-event-oth:hover, .btn-modal-event-techz:hover, .btn-modal-event-trainz:hover, .btn-modal-event-confz:hover, .btn-modal-event-casualz:hover,\n.btn-modal-event-hbw:hover, .btn-modal-event-off-duty.active, .btn-modal-event-train.active, .btsn-modal-event-sick.active, .btsn-modal-event-kids.active,\n.btn-modal-event-phol.active, .btn-modal-event-oth.active, .btn-modal-event-techz:active,.btn-modal-event-trainz:active, .btn-modal-event-confz:active,\n.btn-modal-event-casualz:active, .btn-modal-event-hbw.active {\n\tbackground: #eaeaea;\n}\n\n.btn:not(.btn-raised):not(.btn-link).not-editable:hover {\n\tbackground: none;\n\tcursor: default;\n}\n\n.btn-modal-event-off-duty:before, .btn-modal-event-train:before, .btn-modal-event-sick:before, .btn-modal-event-kids:before,\n.btn-modal-event-phol:before, .btn-modal-event-oth:before, .btn-modal-event-techz:before, .btn-modal-event-trainz:before, .btn-modal-event-confz:before,\n .btn-modal-event-casualz:before, .btn-modal-event-hbw:before {\n\tfont-family: \"Material Icons\";\n\tfont-size: 34px;\n\tposition: absolute;\n\tcontent: '';\n\ttop: 5px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n}\n.btn-modal-event-off-duty:before {\n\tcontent: \"\\E430\";\n\tcolor: #f39c12; /* Off duty color */\n}\n.btn-modal-event-train:before {\n\tcontent: \"\\E80C\";\n\tcolor: #9b59b6; /* Training color */\n}\n.btn-modal-event-sick:before {\n\tcontent: \"\\E53A\";\n\tcolor: #c0392b; /* Sick color */\n}\n.btn-modal-event-kids:before {\n\tcontent: \"\\F19B\";\n\tcolor: #d46659; /* Kids color */\n}\n.btn-modal-event-phol:before {\n\tcontent: \"\\E16B\";\n\tcolor: #0077B5; /* Phol color */\n}\n.btn-modal-event-hbw:before {\n\tcontent: \"\\E88A\";\n\tcolor: #c0aa16; /* Home based working color */\n}\n.btn-modal-event-oth:before {\n\tcontent: \"\\E878\";\n\tcolor: #1abc9c; /* Other color */\n}\n\n.slds-modal__header .btn:not(.btn-raised):not(.btn-link):hover {\n\tbackground: inherit;\n}\n\n/** Selected button **/\n\n::ng-deep .p-selectbutton .p-button.p-state-default {\n  border: none;\n\tbackground: #ffffff;\n\tcolor: #0077B5;\n}\n\n::ng-deep .p-selectbutton .p-button.p-state-active {\n  background: #0077B5;\n  color: #FFFFFF;\n}\n\n/** Datepicker **/\n\n::ng-deep .custom-p-calendar {\n  width: auto;\n  border: 1px solid #ccc;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  position: fixed !important;\n  bottom: 300px;\n  left: 70px;\n}\n\n::ng-deep .p-datepicker {\n  color: #333;\n}\n\n::ng-deep .p-datepicker-header {\n  padding: 10px;\n  color: #333;\n}\n\n::ng-deep.p-datepicker-title {\n\tmargin: 6px 35px;\n  display: flex;\n  justify-content: space-between;\n}\n\n::ng-deep .p-datepicker-title .p-datepicker-year {\n\tmargin-left: 6px;\n}\n\n::ng-deep .p-datepicker table th {\n  background-color: #E0E0E0;\n  padding: 5px;\n}\n\n::ng-deep .p-datepicker table td > span {\n  background-color: #ffffff;\n  padding: 10px;\n}\n\n::ng-deep .p-datepicker table td:hover > span {\n  background-color: #E0E0E0;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #E0E0E0;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-today > span {\n  background-color: #0077B5;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #0077B5;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-other-month > span {\n  color: #E0E0E0;\n}\n\n::ng-deep .p-datepicker table td.p-datepicker-other-month:hover > span {\n  background-color: #EEEEEE;\n  color: #ffffff;\n  padding: 8px;\n  border-radius: 50%;\n  outline: 1px solid #EEEEEE;\n}\n\n::ng-deep span.p-disabled {\n  color: #d3d3d3;\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (max-width: 768px) {\n  #type-event {\n    display: flex;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
